<template>
    <div>
        <transfer-filter :action="filterAction" @exportExcel="exportExcel"></transfer-filter>

        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
import requestsColumns from './datatable/requests-columns'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import $ from "jquery";
import transferColumns from "@/views/openBanking/components/manage-access/datatable/transfer-columns";
import TransferFilter from "./transfer-filter.vue";
import {KTApp} from "@/plugins/core/app";
import axios from "axios";
import {i18n} from "@/plugins/i18n";

export default {

    components: {
        TransferFilter,
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "bank_transfer",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('open-banking/requests/common/bank-transfer/get'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: transferColumns,
            }
        },
    },
    methods: {
        exportExcel() {
            let btn = $('#export_excel')
            KTApp.progress(btn)

            axios({
                url: ApiUrl.path(`open-banking/requests/common/bank-transfer/export-excel`),
                method: 'POST',
                params: this.query,
                responseType: 'blob',
            }).then((response) => {
                KTApp.unprogress(btn);
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'transfer-transactions.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            }).catch(({response}) => {
                this.toastr.error(i18n.t('message.an_error_accord'))
                KTApp.unprogress(btn)
            })
        },
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        checkbox_changed(e) {
            let checkbox = $('#application_checkbox')

            if (checkbox.is(":checked"))
                this.query.my_requests = 1
            else
                this.query.my_requests = 0

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style>

</style>